module.exports = __webpack_public_path__ + "static/Implant bridge smile after-08b702e9b8ea7636f6c0b54070b3d0d7.jpg";